import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { ScoreProgressBar } from "../../assessmentSessions/launch/progress/ScoreProgressBar";
import { DashboardSummary } from "../utilities/generateDashboardSummary";

export interface AverageScoreProgressBarProps {
    summary: DashboardSummary,
    title: string,
    footer: string,
    assessmentType: AssessmentType,
}

/**
 * Show an average score as a progress bar, with supporting data around it.
 */
export const AverageScoreProgressBar = (props: AverageScoreProgressBarProps) => {
    const {
        summary,
        title,
        footer,
        assessmentType,
    } = props;

    const { t } = useTranslation();

    return (
        <div className="text-center" style={{ width: '100%' }}>
            <div>
                <strong>
                    {title}
                </strong>
            </div>
            <Row>
                <Col>
                </Col>
                <Col xs="auto">
                    <ScoreProgressBar
                        value={summary.averageScore}
                        title={t('averageScoreProgressBar.average', 'Average')}
                        assessmentType={assessmentType}
                    />
                </Col>
                <Col>
                </Col>
            </Row>
            <div className="text-muted">
                <small>
                    {footer}
                </small>
            </div>
        </div>
        );
};